import { GetCohortQuery } from "generated-graphql/graphql";
import { NewMexicoSummary } from "./NewMexicoSummary";

type CohortData = NonNullable<GetCohortQuery["cohort"]>;

interface StateSummaryProps {
  cohort: CohortData;
}

/**
 * State-specific summary component that renders different content
 * based on the cohort's state. This allows for state-specific
 * calculations and displays (e.g., fee calculations for NM).
 */
export function StateSummary({ cohort }: StateSummaryProps) {
  const state = cohort.state;

  switch (state) {
    case "NM":
      return <NewMexicoSummary cohort={cohort} />;
    // Add more states as needed:
    // case "AR":
    //   return <ArkansasSummary cohort={cohort} />;
    // case "OH":
    //   return <OhioSummary cohort={cohort} />;
    default:
      // No state-specific summary for other states
      return null;
  }
}
